<div class="modal-header" *ngIf="!nested">
    {{title.toUpperCase() | translate}}
</div>
<div [class.modal-body]="!nested">
    <div [dir]="nested ? null : (dir || 'rtl')">
        <table class="w-100 object-viewer">
            <tbody>
                <tr *ngFor="let row of rows">
                    <td class="text-primary">{{row.key.toUpperCase() | translate}}: </td>
                    <td class="value" [ngSwitch]="row.type" [class.copyable]="canCopy(row)"
                        [title]="canCopy(row) ? ('COPY' | translate) : null"
                        (click)="canCopy(row) && copyValue($event)">
                        <input *ngSwitchCase="'boolean'" type="checkbox" [checked]="row.value" disabled>
                        <span *ngSwitchCase="'datetime'" dir="ltr">{{row.value | dateformater : 1 : lang}}</span>
                        <span *ngSwitchCase="'date'" dir="ltr">{{row.value | dateformater : 2 : lang}}</span>
                        <span *ngSwitchCase="'number'" dir="ltr">{{row.value}}</span>
                        <span *ngSwitchCase="'bytes'">{{row.value}}</span>
                        <app-object-viewer *ngSwitchCase="'object'" class="nested" [nested]="true"
                            [depth]="depth + 1" [dir]="dir" [obj]="row.value">
                        </app-object-viewer>
                        <ng-container *ngSwitchCase="'objects'">
                            <app-object-viewer *ngFor="let item of row.value" class="nested" [nested]="true"
                                [depth]="depth + 1" [dir]="dir" [obj]="item">
                            </app-object-viewer>
                        </ng-container>
                        <pre *ngSwitchCase="'json'" dir="ltr">{{row.value}}</pre>
                        <span *ngSwitchDefault>{{row.value}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
